<route>
{
  "name": "course", "meta": {
    "order": 1,
    "isVisible": false,
    "iconName": "mdi-home"
  }
}
</route>

<template>
  <div>
    <page-title
      :title="$t('pages.courses.title') + ': ' + formData.name ? formData.name : ''">
      <v-btn
        outlined
        :to="{ name: 'chapterAdd', params: { id: $route.params.id } }"
        class="ml-3"
        color="success">
        <v-icon
          class="ml-3">
          mdi-plus-thick
        </v-icon>
        {{$t('general.add')}}
      </v-btn>
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-row
      v-if="!pageDataIsReady"
      >
      <v-col
        cols="12">
        <v-skeleton-loader
          type="table"
          ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-data-table
      v-if="pageDataIsReady"
      class="report-table"
      :headers="headers"
      :items="cards"
      :options="{
        itemsPerPage: 200
      }"
      disable-sort
    >
      <template v-slot:item.actions="{ item }">
        <v-row 
          v-if="item && item._id"
          class="flex-nowrap">
          <v-col cols="6" class="px-0">
            <v-btn
              icon
              color="primary"
              :to="{ name: 'chapterEdit', params: { id: item._id.$oid } }">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" class="pr-0">
            <v-btn
              icon
              color="primary"
              :to="{ name: 'chapter', params: { id: item._id.$oid } }"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template slot="item.image" slot-scope="props">
          <router-link 
            v-if="props && props.item._id"
            :to="{ name: 'chapter', params: { id: props.item._id.$oid } }">
            <v-avatar
              tile
              class="btn pointer my-2 ml-2 rounded-lg"
              size="48">
              <v-img 
                :src="props.item.image">
              </v-img>
            </v-avatar>
          </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import faker from 'faker'
faker.locale = 'fa'
export default {
  name: 'coursePage',
  layout: APP_CONFIG.layout.mainPanelLayout,
  data () {
    return {
      pageDataIsReady: false,
      formData: {},
      cardReview: {
        title: this.$t('general.reviewPreviousChapter'),
        imageUrl: '/img/streamlinevector/1.svg'
      },
      cards: []
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('models.order'),
          width: 32,
          value: 'order'
        },
        {
          text: '', 
          width: 64,
          value: 'image'
        },
        {
          text: this.$t('models.name'),
          value: 'name'
        },
        {
          text: this.$t('models.description'),
          value: 'description'
        },
        {
          text: '',
          value: 'actions'
        },
      ]
    },
  },
  mounted () {
    this.preLoadData()
    this.$store.dispatch('course/getChapters', {
      params: {
        course: this.$route.params.id
      }
    }).then((response) => {
      this.cards = response.data
      this.pageDataIsReady = true
    })
  },
  methods: {
    preLoadData () {
      this.$store.dispatch('course/getById', {
        id: this.$route.params.id
      }).then((response) => {
        this.formData = response.data        
      })
    },
    toChapterPage (item) {
      this.$router.push(`/chapter/${item._id.$oid}`)
    },
    toReviewPreviousChapter () {
      this.$router.push('/coursesList')
    }
  }
}
</script>
